function formatDigits(digits: string): string {
  return digits.length >= 2 ? digits : `0${digits}`;
}

export { formatDigits };
